import { PersonAddOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import { memo, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ScreenContent from "../../../../../components/layout/ScreenContent";
import TitledHeaderWithSearch from "../../../../../components/layout/TitledHeaderWithSearch";
import { loanDrilldownSidebarTypes } from "../../../../../constants/enums/loanDrilldownScreenSidebarOptions";
import { sidebarTypeToggle } from "../../../../../redux/actions/sidebarActions";
import LoanDrilldownTabPanel from "../../LoanDrilldownTabPanel";
import BorrowerSummaryCardList from "./components/BorrowerSummaryCardList";
import LoanBorrowerDetailsCard from "./LoanBorrowerDetailsCard";
import Flx from "../../../../../components/layout/Flx";
import { useReduxHook } from "../../../../../hooks/useReduxHook";
import RedesignBanner from "../../../../../components/ui/RedesignBanner";

// const CARD_WIDTH = 600;
const LoanDrilldownBorrowersTabRedesign = ({ children }) => {
  const ref = useRef();

  const { borrowerId } = useParams();
  const navigate = useNavigate();
  const { id: loanId } = useParams();
  const loanDrilldown = useSelector((state) => state?.loanDrilldown);
  const borrowers = useSelector(
    (state) => state?.loanDrilldown?.borrowers || []
  );
  const { isHighLevelUser } = useReduxHook();
  const [redesign, setRedesign] = useState(false);
  // Find the selected borrower based on URL parameter
  const activeBorrowerData = useMemo(() => {
    if (!borrowerId || !borrowers.length) return null;
    return borrowers.find((borrower) => borrower._id === borrowerId) || null;
  }, [borrowerId, borrowers]);

  if (redesign && isHighLevelUser) {
    return (
      <Flx column>
        <LoanDrilldownBorrowersTabRedesign />
        <RedesignBanner show active={redesign} onClick={setRedesign} />
      </Flx>
    );
  }

  return (
    <LoanDrilldownTabPanel>
      <TitledHeaderWithSearch
        title={"Borrowers"}
        endContent={<AddBorrowerButton />}
        borderColor={"#eeeeee"}
      />

      {/* <ScreenContent
        sx={{
          flexGrow: 1,
          width: "100%",
          margin: "0px auto",
        }}
      >
        <BorrowerSummaryCardList
          // activeBorrowerId={activeBorrowerData?._id}
          activeBorrowerData={activeBorrowerData}
        />
        <LoanBorrowerDetailsCard borrower={activeBorrowerData} />
      </ScreenContent> */}
      <ScreenContent
        sx={{
          flexGrow: 1,
          width: "100%",
          margin: "0px auto",
        }}
      >
        <Flx wrap grow={1} sx={{ alignItems: "flex-start" }}>
          <BorrowerSummaryCardList
            // activeBorrowerId={activeBorrowerData?._id}
            activeBorrowerData={activeBorrowerData}
          />
          <LoanBorrowerDetailsCard borrower={activeBorrowerData} />
        </Flx>
      </ScreenContent>
    </LoanDrilldownTabPanel>
  );
};

/**
 * -------------- LOAN BORROWER DETAILS --------------
 */

/**
 * -------------- LOAN BORROWER OTHER --------------
 */

// -------------------------- UI COMPONENTS --------------------------

const AddBorrowerButton = memo(() => {
  const dispatch = useDispatch();

  const handleToggle = () => {
    dispatch(sidebarTypeToggle(loanDrilldownSidebarTypes.ADD_BORROWER));
  };

  return (
    <Button
      sx={{ ml: 1 }}
      startIcon={<PersonAddOutlined />}
      onClick={handleToggle}
    >
      Add Borrower
    </Button>
  );
});

export default LoanDrilldownBorrowersTabRedesign;
